<!-- AbsoluteURL (custom mark) -->
<script lang="ts">
    import type {MarkComponentProps} from '@portabletext/svelte'

    // Property custom marks receive from @portabletext/svelte when redered
    export let portableText: MarkComponentProps<{
      href?: string
    }>

    $: ({value} = portableText)
  </script>
  
  {#if value.href}
    <a href={value.href} data-sveltekit-reload>
      <!-- Marks receive children which you can render with Svelte's slots -->
      <slot />
    </a>
  {:else}
    <slot/>
  {/if}